import { render, staticRenderFns } from "./ImageUploadIcon.vue?vue&type=template&id=4e80d3b9&"
import script from "./ImageUploadIcon.vue?vue&type=script&lang=ts&"
export * from "./ImageUploadIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports